import { createRouter } from '@tanstack/react-router';

import { queryClient } from '@/lib/query-client';
import { NotFoundComponent } from '@/components/shared/not-found-component';

import { routeTree } from './route-tree';

export const router = createRouter({
  routeTree,
  defaultPendingComponent: () => (
    <div>
      {/* TODO: create loading for pending component ideal */}
      <p>Loading</p>
    </div>
  ),
  defaultErrorComponent: () => <NotFoundComponent />,
  defaultNotFoundComponent: () => <NotFoundComponent />,
  context: {
    authStore: undefined!,
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

export type AppRoutePath =
  (typeof router)['routesById'][keyof (typeof router)['routesById']]['fullPath'];

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
